"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _swiper = _interopRequireWildcard(require("swiper"));
var _react2 = require("swiper/react");
require("swiper/swiper-bundle.min.css");
var _styles = require("@material-ui/core/styles");
var _styles2 = require("./styles");
var _Zoom = _interopRequireDefault(require("./assets/Zoom.svg"));
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
_swiper.default.use([_swiper.Navigation, _swiper.Pagination, _swiper.Scrollbar, _swiper.A11y, _swiper.Thumbs, _swiper.Keyboard, _swiper.Mousewheel, _swiper.Zoom, _swiper.Lazy]);
var breakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 1,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 1,
    spaceBetween: 10
  }
};
var thumbBreakpoints = {
  // when window width is >= 320px
  0: {
    slidesPerView: 4,
    spaceBetween: 10
  },
  // when window width is >= 768px
  768: {
    slidesPerView: 10,
    spaceBetween: 10
  }
};
var ImageSwiper = function ImageSwiper(_ref) {
  var slides = _ref.slides,
    thumbnails = _ref.thumbnails,
    other = _objectWithoutProperties(_ref, ["slides", "thumbnails"]);
  var _useState = (0, _react.useState)(function () {}),
    _useState2 = _slicedToArray(_useState, 2),
    zoomToggle = _useState2[0],
    setZoomToggle = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    mainSwiper = _useState4[0],
    setMainSwiper = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeSlide = _useState6[0],
    setActiveSlide = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    thumbsSwiper = _useState8[0],
    setThumbsSwiper = _useState8[1];
  var defaultProps = {
    a11y: true,
    breakpoints: breakpoints,
    centeredSlides: true,
    keyboard: true,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    noSwiping: false,
    onSwiper: setMainSwiper,
    onSlideChange: function onSlideChange(swiper) {
      return setActiveSlide(swiper.activeIndex);
    },
    onAfterInit: function onAfterInit(swiper) {
      return setZoomToggle(function () {
        return swiper.zoom.toggle;
      });
    },
    preloadImages: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 150,
    tag: 'section',
    thumbs: {
      swiper: thumbsSwiper
    },
    wrapperTag: 'ul',
    zoom: {
      maxRatio: 2,
      minRatio: 1,
      toggle: true
    }
  };
  var defaultThumbProps = {
    breakpoints: thumbBreakpoints,
    tag: 'section',
    wrapperTag: 'ul',
    onSwiper: setThumbsSwiper,
    slidesPerView: 10,
    slidesPerGroup: 1,
    loopFillGroupWithBlank: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    scrollbar: {
      draggable: true
    },
    preloadImages: true,
    speed: 150
  };
  var mergedProps = _objectSpread(_objectSpread({}, defaultProps), other);
  var showThumbnails = thumbnails.length > 1;
  var slideTo = function slideTo(index) {
    return mainSwiper.slideTo(index);
  };
  var slideNext = function slideNext() {
    return mainSwiper.slideNext();
  };
  var handleMiddleClick = function handleMiddleClick() {
    switch (activeSlide) {
      case 0:
      case 1:
      case slides.length - 1:
      case slides.length - 2:
      case slides.length - 3:
        slideTo(2);
        break;
      default:
        slideNext();
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_styles2.StyledImageSwiper, null, /*#__PURE__*/_react.default.createElement(_react2.Swiper, mergedProps, /*#__PURE__*/_react.default.createElement("button", {
    className: "swiper-button-prev",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowLeft.default, {
    style: {
      fontSize: 40
    }
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "swiper-button-next",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowRight.default, {
    style: {
      fontSize: 40
    }
  })), mergedProps.zoom && /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return zoomToggle();
    },
    onKeyPress: function onKeyPress(event) {
      return event.key === '' && zoomToggle();
    },
    className: "zoom-icon",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Zoom icon",
    src: _Zoom.default
  })), slides.map(function (slide) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: slide.key,
      tag: "li",
      zoom: true
    }, slide);
  }))), showThumbnails && /*#__PURE__*/_react.default.createElement(_styles2.StyledThumbs, null, /*#__PURE__*/_react.default.createElement(_react2.Swiper, defaultThumbProps, thumbnails.map(function (slide) {
    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: slide.key,
      tag: "li"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "slide-padding"
    }, slide));
  }))), /*#__PURE__*/_react.default.createElement(_styles2.StyledPagination, null, slides.length > 5 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(activeSlide === 0 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(0);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to 1")), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(activeSlide === 1 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(1);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to 2")), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(activeSlide > 1 && activeSlide < slides.length - 2 ? ' slide-pagination-bullet-active' : ''),
    onClick: handleMiddleClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(activeSlide === slides.length - 3 ? '3' : 'next'))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(activeSlide === slides.length - 2 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(slides.length - 2);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(slides.length - 1))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "slide-pagination-bullet".concat(activeSlide === slides.length - 1 ? ' slide-pagination-bullet-active' : ''),
    onClick: function onClick() {
      return slideTo(slides.length - 1);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Slide to ".concat(slides.length)))) : slides.map(function (_, index) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      key: "slide-pagination-".concat(Math.random().toString()),
      className: "slide-pagination-bullet".concat(activeSlide === index ? ' slide-pagination-bullet-active' : ''),
      onClick: function onClick() {
        return slideTo(index);
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Slide to ".concat(index + 1)));
  })));
};
ImageSwiper.propTypes = {
  slides: (0, _propTypes.arrayOf)(_propTypes.object),
  thumbnails: (0, _propTypes.arrayOf)(_propTypes.object)
};
ImageSwiper.defaultProps = {
  slides: [],
  thumbnails: []
};
var _default = ImageSwiper;
exports.default = _default;